import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../shared/shared.module';
import { UtilsModule } from './../utils/utils.module';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { PortalComponent } from './portal.component';
import { portalRoutes } from './portal.routing';
// import { ProductsModule } from './products/products.module';
import { ProfileComponent } from './profile/profile.component';
import { SettingsComponent } from './settings/settings.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PortalDisclaimerComponent } from './shared/portal-disclaimer/portal-disclaimer.component';
import { ImportantNoticeComponent } from './shared/important-notice/important-notice.component';
// import { SendOtpComponent } from './shared/send-otp/send-otp.component';
import { MobileConfirmationComponent } from './shared/mobile-confirmation/mobile-confirmation.component';
import { RequestComponent } from './profile/request/request.component';
import { AccountStatementComponent } from './profile/request/account-statement/account-statement.component';

import { PortalDashboardComponent } from './portal-dashboard/portal-dashboard.component';
import { CardBalanceComponent } from './portal-dashboard/card-balance/card-balance.component';
import { MarketActivityCardComponent } from './portal-dashboard/market-activity-card/market-activity-card.component';
import { EqutiesComponent } from './portal-dashboard/equties/equties.component';
import { CalsPortfolioComponent } from './portal-dashboard/equties/cals-portfolio/cals-portfolio.component';
import { CalsTransactionsComponent } from './portal-dashboard/equties/cals-transactions/cals-transactions.component';
import { CalDisclaimerComponent } from './portal-dashboard/cal-disclaimer/cal-disclaimer.component';
import { LedgerComponent } from './portal-dashboard/ledger/ledger.component';
import { LedgerSummaryComponent } from './portal-dashboard/ledger/ledger-summary/ledger-summary.component';
import { LedgerPortfolioComponent } from './portal-dashboard/ledger/portfolio/ledger-portfolio.component';
import { EquitySummaryComponent } from './portal-dashboard/equties/equity-summary/equity-summary.component';
import { DownloadReportsComponent } from './portal-dashboard/equties/download-reports/download-reports.component';
import { DefaultSectionComponent } from './portal-dashboard/default-section/default-section.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MarginTradingComponent } from './portal-dashboard/margin-trading/margin-trading.component';
import { MarginTradingSummaryComponent } from './portal-dashboard/margin-trading/margin-trading-summary/margin-trading-summary.component';
import { TradingPortfolioComponent } from './portal-dashboard/margin-trading/portfolio/trading-portfolio.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { InvestmentPlansComponent } from './portal-dashboard/investment-plans/investment-plans.component';
import { SuperAdminModule } from '../super-admin/super-admin.module';
import { ApprovalProgressComponent } from './portal-dashboard/card-balance/approval-progress/approval-progress.component';
import { UtSliderComponent } from './portal-dashboard/ut-slider/ut-slider.component';
import { FormElementModule } from './product-signup/form-element/form-element.module';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    RouterModule.forChild(portalRoutes),
    SharedModule,
    // ProductsModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    // BrowserModule, // Removed as it should only be in AppModule
    DropDownsModule,
    BsDatepickerModule.forRoot(),
    ChartsModule,
    BrowserAnimationsModule,
    GridModule,
    InputsModule,
    NgApexchartsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    SuperAdminModule,
    FormElementModule,
  ],
  declarations: [
    PortalComponent,
    EmailConfirmationComponent,
    ProfileComponent,
    ConfirmPasswordComponent,

    SettingsComponent,

    PortalDisclaimerComponent,
    ImportantNoticeComponent,
    // SendOtpComponent,
    MobileConfirmationComponent,
    RequestComponent,
    AccountStatementComponent,
    LedgerSummaryComponent,
    PortalDashboardComponent,
    CardBalanceComponent,
    MarketActivityCardComponent,
    EqutiesComponent,
    CalsPortfolioComponent,
    CalsTransactionsComponent,
    CalDisclaimerComponent,
    MarginTradingComponent,
    MarginTradingSummaryComponent,
    TradingPortfolioComponent,
    LedgerComponent,
    LedgerPortfolioComponent,

    EquitySummaryComponent,
    DownloadReportsComponent,
    DefaultSectionComponent,
    InvestmentPlansComponent,
    ApprovalProgressComponent,
    UtSliderComponent,
  ],
  exports: [],
})
export class PortalModule {}
